<template>
  <div class="Filtersearch">
    <div class="Filtersearchinput" v-if="Filtersearchlist.length > 0">
      <div
        class="Filtersearchinput-item"
        v-for="(item, index) in itemindex"
        :key="index"
      >
        <div class="wen-item">
          <div class="wen-item-tips">
            <el-tooltip
              v-if="Filtersearchlist[index].msg"
              class="item"
              effect="dark"
              :content="Filtersearchlist[index].msg"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          {{ Filtersearchlist[index].name }}
        </div>
        <div class="wen-input">
          <el-input
            v-if="Filtersearchlist[index].type == 'input'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :placeholder="Filtersearchlist[index].placeholder"
            :clearable="Filtersearchlist[index].clearable"
          ></el-input>
           <el-checkbox v-model="from[Filtersearchlist[index].model]" :true-label="1" false-label=""    v-if="Filtersearchlist[index].type == 'checkbox'">{{ Filtersearchlist[index].placeholder }}</el-checkbox>
          <el-select
            v-else-if="Filtersearchlist[index].type == 'select'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :clearable="Filtersearchlist[index].clearable"
            :disabled="Filtersearchlist[index].disabled"
            :filterable="Filtersearchlist[index].filterable"
            :multiple="Filtersearchlist[index].multiple"
            :placeholder="Filtersearchlist[index].placeholder"
          >
            <el-option
              :label="itenchild[Filtersearchlist[index].label]"
              v-for="(itenchild, i) in Filtersearchlist[index].selectoption"
              :value="itenchild[Filtersearchlist[index].value]"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="Filtersearchlist[index].type == 'selectlinkage'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :clearable="Filtersearchlist[index].clearable"
            :disabled="Filtersearchlist[index].disabled"
            :filterable="Filtersearchlist[index].filterable"
            :multiple="Filtersearchlist[index].multiple"
            :placeholder="Filtersearchlist[index].placeholder"
            @clear="selectlinkageclear"
          >
            <el-option
            @click.native="handleOptionClick(itenchild)"
              :label="itenchild[Filtersearchlist[index].label]"
              v-for="(itenchild, i) in Filtersearchlist[index].selectoption"
              :value="itenchild[Filtersearchlist[index].value]"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="Filtersearchlist[index].type == 'selectAll'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :clearable="Filtersearchlist[index].clearable"
            :filterable="Filtersearchlist[index].filterable"
            :multiple="Filtersearchlist[index].multiple"
            :placeholder="Filtersearchlist[index].placeholder"
          >
            <li
              class="el-select-dropdown__item"
              :class="{ selected: isFullySelected(index) }"
              @click="onHandleSelectedAll(index)"
            >
              <span>全选</span>
            </li>
            <el-option
              :label="itenchild[Filtersearchlist[index].label]"
              v-for="(itenchild, i) in Filtersearchlist[index].selectoption"
              :value="itenchild[Filtersearchlist[index].value]"
              :key="i"
            ></el-option>
          </el-select>

          <el-select
            v-else-if="Filtersearchlist[index].type == 'selectChange'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :clearable="Filtersearchlist[index].clearable"
            :filterable="Filtersearchlist[index].filterable"
            :multiple="Filtersearchlist[index].multiple"
            :placeholder="Filtersearchlist[index].placeholder"
            @change="selectChange"
          >
            <el-option
              :label="itenchild[Filtersearchlist[index].label]"
              v-for="(itenchild, i) in Filtersearchlist[index].selectoption"
              :value="itenchild[Filtersearchlist[index].value]"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            v-else-if="Filtersearchlist[index].type == 'selectAllChange'"
            v-model="from[Filtersearchlist[index].model]"
            style="width: 100%"
            :clearable="Filtersearchlist[index].clearable"
            :filterable="Filtersearchlist[index].filterable"
            :multiple="Filtersearchlist[index].multiple"
            :placeholder="Filtersearchlist[index].placeholder"
            @change="selectAllChange"
            collapse-tags
          >
            <li
              class="el-select-dropdown__item"
              :class="{ selected: isFullySelected(index) }"
              @click="handleSelectAll(index)"
            >
              <span>全选</span>
            </li>
            <el-option
              :label="itenchild[Filtersearchlist[index].label]"
              v-for="(itenchild, i) in Filtersearchlist[index].selectoption"
              :value="itenchild[Filtersearchlist[index].value]"
              :key="i"
            ></el-option>
          </el-select>
          <el-date-picker
            v-else-if="Filtersearchlist[index].type == 'daterange'"
            type="daterange"
            :clearable="Filtersearchlist[index].clearable"
            style="width: 100%"
            v-model="from[Filtersearchlist[index].model]"
            :start-placeholder="Filtersearchlist[index].startplaceholder"
            :end-placeholder="Filtersearchlist[index].endplaceholder"
            :picker-options="
              createPickerOptions(Filtersearchlist[index].pickerOptions)
            "
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="(val) => addTimeChange(val, Filtersearchlist[index])"
          >
          </el-date-picker>
          <el-date-picker
            v-else-if="Filtersearchlist[index].type == 'datetimerange'"
            type="datetimerange"
            :clearable="Filtersearchlist[index].clearable"
            style="width: 100%"
            v-model="from[Filtersearchlist[index].model]"
            :start-placeholder="Filtersearchlist[index].startplaceholder"
            :end-placeholder="Filtersearchlist[index].endplaceholder"
            :format="
              Filtersearchlist[index].format
                ? Filtersearchlist[index].format
                : 'yyyy-MM-dd HH:mm'
            "
            value-format="yyyy-MM-dd HH:mm"
            @change="(val) => addTimeChange(val, Filtersearchlist[index])"
          >
          </el-date-picker>
          <div
            v-else-if="Filtersearchlist[index].type == 'maxinput'"
            style="display: flex; align-items: center"
          >
            <el-input
              v-model="from[Filtersearchlist[index].minmodel]"
              style="width: 100%"
              :placeholder="Filtersearchlist[index].placeholder"
              :clearable="Filtersearchlist[index].clearable"
            ></el-input>
            <div>%</div>
            —
            <el-input
              v-model="from[Filtersearchlist[index].maxmodel]"
              style="width: 100%"
              :placeholder="Filtersearchlist[index].placeholder"
              :clearable="Filtersearchlist[index].clearable"
            ></el-input>
            <div>%</div>
          </div>
          <div
            v-else-if="Filtersearchlist[index].type == 'numinput'"
            style="display: flex; align-items: center"
          >
            <el-input
              v-model.number="from[Filtersearchlist[index].minmodel]"
              style="width: 100%"
              @blur="
                () =>
                  (from[Filtersearchlist[index].minmodel] =
                    utilsTool.validateInput(
                      from[Filtersearchlist[index].minmodel]
                    ))
              "
              :placeholder="Filtersearchlist[index].placeholdermin"
              :clearable="Filtersearchlist[index].clearable"
            ></el-input>
            —
            <el-input
              v-model.number="from[Filtersearchlist[index].maxmodel]"
              style="width: 100%"
              :placeholder="Filtersearchlist[index].placeholdermax"
              :clearable="Filtersearchlist[index].clearable"
              @blur="
                () =>
                  (from[Filtersearchlist[index].maxmodel] =
                    utilsTool.validateInput(
                      from[Filtersearchlist[index].maxmodel]
                    ))
              "
            ></el-input>
          </div>
          <div
            v-else-if="Filtersearchlist[index].type == 'zfTime'"
            style="display: flex; align-items: center"
          >
            <el-input
              v-model="from[Filtersearchlist[index].minmodel]"
              style="width: 100%"
              :placeholder="Filtersearchlist[index].placeholder"
              :clearable="Filtersearchlist[index].clearable"
              @blur="
                () =>
                  (from[Filtersearchlist[index].minmodel] =
                    utilsTool.filterUnNumber(
                      from[Filtersearchlist[index].minmodel],
                      true
                    ))
              "
              @change="changeZFTime(Filtersearchlist[index])"
            ></el-input>
            —
            <el-input
              v-model="from[Filtersearchlist[index].maxmodel]"
              style="width: 100%"
              :placeholder="Filtersearchlist[index].placeholder"
              :clearable="Filtersearchlist[index].clearable"
              @change="changeZFTime(Filtersearchlist[index])"
              @blur="
                () =>
                  (from[Filtersearchlist[index].maxmodel] =
                    utilsTool.filterUnNumber(
                      from[Filtersearchlist[index].maxmodel],
                      true
                    ))
              "
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-expand" v-if="Filtersearchlist.length > 5">
      <el-button type="text" v-if="downshow" @click="downshowchange"
        ><i class="el-icon-arrow-down"></i> 展开</el-button
      >
      <el-button type="text" v-else @click="downshowchange"
        ><i class="el-icon-arrow-up"></i> 收起</el-button
      >
    </div>
    <div class="Filtersearchserch">
      <div class="Filtersearchserch-left">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          class="bjsearch"
          @click="Refresh"
        ></el-button>

        <slot name="left"></slot>
      </div>
      <div class="Filtersearchserch-right">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >查询</el-button
        >
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import utilsTool from "@/utils/tools/tool";
export default {
  props: {
    /** 文件列 */
    list: {
      type: Array,
      default: () => [],
    },
    /** 文件列 */
    fromdata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      downshow: false,
      Filtersearchlist: [],
      from: {},
      itemindex: 5,
      utilsTool,
      // 时间范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        console.log(newVal, "11111111");
        // console.log(newVal,'11111111')
        this.Filtersearchlist = JSON.parse(JSON.stringify(newVal));
        // this.itemindex =
        //   this.Filtersearchlist.length > 5 ? 5 : this.Filtersearchlist.length;
        // this.downshow = true;
      },
      deep: true,
      immediate: true,
    },
    fromdata: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, "222");
        this.getfrom();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.Filtersearchlist = JSON.parse(JSON.stringify(this.list));
    // this.itemindex =
    //   this.Filtersearchlist.length > 5 ? 5 : this.Filtersearchlist.length;
    this.itemindex = this.Filtersearchlist.length;
  },
  mounted() {
    this.getfrom();
  },
  methods: {
    handleOptionClick(e){
      // console.log(e,'123124342351235')
this.$emit('handleOptionClick',e)
    },
    selectlinkageclear(){
this.$emit('selectlinkageclear',true);
    },
    /**
     * 全选/反选
     */
    onHandleSelectedAll(index) {
      console.log(
        this.Filtersearchlist[index].model,
        this.Filtersearchlist[index].selectoption
      );
      if (
        this.from[this.Filtersearchlist[index].model].length ===
        this.Filtersearchlist[index].selectoption.length
      ) {
        // 取消全选
        this.from[this.Filtersearchlist[index].model] = [];
      } else {
        this.from[this.Filtersearchlist[index].model] = this.Filtersearchlist[
          index
        ].selectoption.map((item) => item[this.Filtersearchlist[index].value]);
      }
    },

    // 创建独立的 pickerOptions 对象
    createPickerOptions(type) {
      if (type == 1) {
        return {
          disabledDate: (time) => {
            return time.getTime() > Date.now();
          },
        };
      } else {
        return {
          disabledDate: (time) => {
            return false;
          },
        };
      }
    },
    /**
     * 判断是否已全选
     */
    isFullySelected(index) {
      const item = this.Filtersearchlist[index];
      const selected = this.from[item.model];
      const options = item.selectoption;

      // 没有选中项，不是全选
      if (!selected || selected.length === 0) return false;

      // 选中项数量与选项数量不一致，不是全选
      if (selected.length !== options.length) return false;

      // 检查所有选项是否都被选中
      const optionValues = options.map((option) => option[item.value]);
      return selected.every((value) => optionValues.includes(value));
    },
    /**
     * 处理全选功能
     */
    handleSelectAll(index) {
      const item = this.Filtersearchlist[index];
      const options = item.selectoption;
      const selected = this.from[item.model];

      if (this.isFullySelected(index)) {
        // 取消全选
        this.from[item.model] = [];
      } else {
        // 全选
        this.from[item.model] = options.map((option) => option[item.value]);
      }

      // 触发change事件
      this.selectAllChange(this.from[item.model]);
    },
    // 修改支付金额起止金额校验
    changeZFTime(e) {
      console.log(e, "e==");
      this.$emit("changeAmt", this.from);
    },
    downshowchange() {
      this.downshow = !this.downshow;
      if (this.downshow) {
        this.itemindex =
          this.Filtersearchlist.length > 5 ? 5 : this.Filtersearchlist.length;
      } else {
        this.itemindex = this.Filtersearchlist.length;
      }
    },
    gettime(e) {
      this.Filtersearchlist.forEach((el) => {
        if (el.type == "daterange") {
          if (this.from[el.startmodel]) {
            this.from[el.model] = [
              this.from[el.startmodel],
              this.from[el.endmodel],
            ];
          }
        }
      });
    },
    addTimeChange(val, e) {
      // 没有开始和结束时间 不赋值
      if (e.startmodel && e.endmodel) {
        if (val) {
          this.from[e.startmodel] = val[0];
          this.from[e.endmodel] = val[1];
        } else {
          console.log(e.defaultValue, "走这里吗");
          // 当指定字段有值时，允许清空不恢复默认值
          var hasClearableWith = e.clearableWith && this.from[e.clearableWith];
          if (e.defaultValue && !hasClearableWith) {
            this.from[e.startmodel] = e.defaultValue[0];
            this.from[e.endmodel] = e.defaultValue[1];
            this.from[e.model] = e.defaultValue;
          } else {
            this.from[e.startmodel] = "";
            this.from[e.endmodel] = "";
          }
        }
      }
    },
    getfrom() {
      this.from = JSON.parse(JSON.stringify(this.fromdata));
      this.gettime();
      console.log("111,ce1", this.from);
    },
    Refresh() {
      this.$emit("Refresh");
    },
    search() {
      this.$emit("search", this.from);
    },
    // 选择下拉  比如选择仓 获取仓id 请求自提点列表
    selectChange(val) {
      console.log(this.from, "eee");
      this.$emit("selectChange", val);
    },
    // 选择下拉 有全选 比如选择仓 获取仓id 请求自提点列表
    selectAllChange(val) {
      console.log(this.from, "eee");
      this.$emit("selectAllChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.Filtersearch {
  .bjsearch {
    background: #333333;
    border-color: #333333;
  }
  margin-bottom: 10px;

  .Filtersearchinput {
    background: #ffffff;

    padding: 12px 0px;
    padding-bottom: 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    .Filtersearchinput-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .wen-item {
        width: 95px;

        margin-right: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #535252;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .wen-item-tips {
          margin-right: 5px;
          padding-top: 5px;
          box-sizing: border-box;
        }
      }
      .wen-input {
        width: 220px;
        /deep/ .el-date-editor--daterange {
          .el-range__icon {
            display: none !important;
          }
        }
        /deep/ .el-date-editor--datetimerange {
          .el-range__icon {
            display: none !important;
          }
        }
      }
    }
  }
  .Filtersearchserch {
    margin-top: 10px;
    background: #ffffff;
    padding: 12px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .Filtersearchserch-left {
      flex: 1;
    }
    .Filtersearchserch-right {
    }
  }
  .btn-expand {
    padding: 0px 15px;
    // padding-top: 0;
    background: #ffffff;
    box-sizing: border-box;
    text-align: right;
  }
}
</style>
